import { render, staticRenderFns } from "./breakdowns-grid.vue?vue&type=template&id=932670c2&"
import script from "./breakdowns-grid.ts?vue&type=script&lang=ts&"
export * from "./breakdowns-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports